/* LinksComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const SteveIo = require("@gluenetworks/steve_core_io");
const Registrations = require("../../../../../../../RegistrationNamespaces");
const Renderer = require("./LinksRenderer");
// Plan statuses where device deletion is disabled
const DEVICE_DELETE_DISABLED_STATUSES = [
    "VALIDATING",
    "BUNDLING",
    "UPLOADING_RESULTS",
    "UPGRADE_COMPLETE",
];

// Plan statuses where device status editing is disabled
const DEVICE_STATUS_EDIT_DISABLED_STATUSES = [
    "DRAFT",
    "VALIDATED",
    "VALIDATING",
    "VALIDATION_ERROR",
    "INVALID",
    "BUNDLING",
    "BUNDLE_ERROR",
    "UPLOADING_RESULTS",
    "UPGRADE_COMPLETE",
];
class LinksComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._gameEditor = context.gameEditor;
        this._plan = this._gameEditor.getPlan();
        this._osPlanDetailsViewModel = context.osPlanDetailsViewModel;

        const planStatus = this._plan.status;
        this._isDeleteDisabled = DEVICE_DELETE_DISABLED_STATUSES.includes(planStatus);
        this._isUpdateDisabled = DEVICE_STATUS_EDIT_DISABLED_STATUSES.includes(planStatus);
        this._context = context;
        this._logger = context.logger;
        this._value = value;
        this._modalUserFeedback = context.modalUserFeedback;
        this._renderer = new Renderer(this);
        this._steveIo = new SteveIo();
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        if (this._value) {
            this._value.on(
                "PropertiesUpdated",
                (this.updateComponent = this.updateComponent.bind(this))
            );
        }
    }

    _unregisterListeners() {
        if (this._value) {
            this._value.removeListener("PropertiesUpdated", this.updateComponent);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();

        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._value = undefined;
            this._steveIo = undefined;
        });
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }

    getValue() {
        return this.getLinks();
    }

    updateComponent(after, before) {
        if (after && before) {
            this.emit("Links", before);
        }
    }

    setLinks(newVal) {
        this._value = newVal;
    }

    getLinks() {
        return this._value;
    }

    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
    removeDevice() {
        const name = this._value.getName();
        const groupkey = this._value;
        const msg = `Are you sure you want to delete ${name} from the OS Plan?`;
        const ids = [groupkey.id];
        return this._gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: msg,
                title: "Delete",
                confirmDetails: {
                    text: "Confirm",
                    type: "destructive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            },
            () => {
                try {
                    return this._gameEditor._removeDevices(ids);
                } catch (error) {
                    return error;
                }
            }
        );
    }

    updateDeviceStatus() {
        // Set the selected device for the action
        this._gameEditor._activeView._selectedLinkForStatusUpdate = this._value;
        this._gameEditor.runAction(Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_UPDATE_DEVICE_STATUSES);
    }
}

module.exports = LinksComponent;
